export const baseAccountListingColumns = [
  {
    label: '',
    value: 'currency-flag',
    handleBarKey: `{{{ currencyToFlag currency '44px' }}}`,
    selected: true,
  },
  {
    label: 'Account Number / IBAN',
    value: 'account-number',
    handleBarKey: `{{#if accountIdentifier.0.accountNumber}}{{accountIdentifier.0.accountNumber}}{{else if accountIdentifier.0.iban}}{{accountIdentifier.0.iban}}{{else}}--{{/if}}`,
    selected: true,
  },
  {
    label: 'Currency',
    value: 'currency',
    handleBarKey: '{{ currency }}',
    selected: true,
  },
  {
    label: 'Country',
    value: 'country',
    handleBarKey: '{{ countryFullName country }}',
    selected: true,
  },
  {
    label: 'Routing Details / SWIFT / BIC',
    value: 'swift-bic',
    handleBarKey: `
    {{#if accountIdentifier.0.bic}}{{accountIdentifier.0.bic}}{{else if accountIdentifier.0.sortCode}}
    {{accountIdentifier.0.sortCode}}{{else}}--{{/if}}
`,
    selected: true,
  },
  {
    label: 'Balance',
    value: 'balance',
    handleBarKey: `{{ currencyPipe availableBalance currencyCode=currency }}`,
    selected: true,
  },
];

export const accountsColumnListing = [
  ...baseAccountListingColumns,
  {
    label: '',
    value: 'more-option',
    handleBarKey: `<span id="more-options">{{{ svgIcon 'more-options-eclipse' '32px' '32px' }}}</span>`,
    selected: true,
  },
];
